// Raw HTML blocks: syntax the schema does not model, kept byte for byte.

import { Node } from "@tiptap/core";
import { blockIdDomAttrs } from "./block-id";

/**
 * Any raw HTML block marked tokenizes (its lexer emits an `html` block token for
 * content starting with a tag). Without this node `@tiptap/markdown` has nothing
 * for that token and escapes the source (`<div>` -> `&lt;div&gt;`). The source
 * is kept in `attrs.raw` and written back unchanged.
 */
export const OpaqueBlock = Node.create({
  name: "opaqueBlock",
  group: "block",
  atom: true,
  selectable: true,

  addAttributes() {
    return { raw: { default: "" } };
  },

  parseHTML() {
    return [{ tag: "div[data-opaque-block]" }];
  },

  // Ignores the merged `HTMLAttributes`, so the block id is written explicitly.
  renderHTML({ node }) {
    return [
      "div",
      { "data-opaque-block": "true", ...blockIdDomAttrs(node) },
      node.attrs?.raw,
    ];
  },

  markdownTokenName: "html",
  parseMarkdown(token, h) {
    // `token.raw` includes trailing blank lines; MarkdownManager puts block
    // separators back itself.
    const raw = (token.raw as string).replace(/\s+$/, "");
    return h.createNode("opaqueBlock", { raw }, []);
  },
  renderMarkdown(node) {
    return node.attrs?.raw as string;
  },
});
